import { Mapper } from '../../../../core/base';
import { AdditionalDataKeyWebEntity } from './additional-data-key.web-entity';
import { AdditionalDataKey } from '../../../../core/domain/models';

export class AdditionalDataKeyWebRepositoryMapper
  implements Mapper<AdditionalDataKeyWebEntity, AdditionalDataKey>
{
  mapFrom(param: AdditionalDataKeyWebEntity): AdditionalDataKey {
    return {
      id: param.id,
      name: param.name,
      displayName: param.displayName,
      isRequired: param.isRequired,
      keyType: param.keyType,
      keySize:param.keySize,
    };
  }

  mapTo(param: AdditionalDataKey): AdditionalDataKeyWebEntity {
    return {
      id: param.id,
      name: param.name,
      displayName: param.displayName,
      isRequired: param.isRequired,
      keyType: param.keyType,
      keySize:param.keySize,
    };
  }
}
